import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

export default class GochipsModelsAdapter extends JSONAPIAdapter
{
	@service() config;
	@service errorManager;

	@computed('config')
	get host()
	{
		return this.config.get('gochipsBackendProtocol')+"://"+this.config.get('gochipsBackendHost')+":"+this.config.get('gochipsBackendPort');
	}

	@computed('config')
	get namespace()
	{
		return this.config.get('gochipsBackendNamespace');
	}

	coalesceFindRequests = true;

	handleResponse(status, headers, payload, requestData) {
		if (!this.isSuccess(status, headers, payload)) {
			const errorMessage = payload?.errors?.[0]?.detail
				|| payload?.errors?.[0]?.title
				|| payload?.error
				|| `Server error: ${status}`;
			this.errorManager.addError(errorMessage, { clearable: true, type: 'ember-data' });
		}
		return super.handleResponse(status, headers, payload, requestData);
	}

	ajax(url, type, options) {
		return super.ajax(url, type, options).catch((error) => {
			if (error.name === 'TypeError' || error.message?.includes('Network') || error.status === 0) {
				this.errorManager.addError('Network error: Unable to connect to server', { clearable: true, type: 'network' });
			}
			throw error;
		});
	}
}

